// extracted by mini-css-extract-plugin
export var container = "_90-1";
export var cornerButtonContainer = "_90-5";
export var disabled = "_90-2";
export var fileContainer = "_90-4";
export var hiddenInput = "_90-3";
export var widthContainer = "_90-0";